import { AeoRecommendationFeedbackKindSchema } from "@redotech/redo-model/aeo/aeo-recommendation";
import { aeoRecommendationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const updateAeoRecommendationFeedback = {
  name: "updateAeoRecommendationFeedback" as const,
  input: z.object({
    recommendationId: aeoRecommendationIdFormat.schema,
    kind: AeoRecommendationFeedbackKindSchema,
    comment: z.string().optional(),
  }),
  output: z.object({}),
};
